
let teamId='';
let eventId='';
let section='';
export function getTeamId() {
    return teamId;
}

export function setTeamId(myTeamid){
    teamId = myTeamid;
}

export function getEventId() {
    return  eventId;
}

export function setEventId(myEventid){
    eventId = myEventid;
}

export function getSection() {
    return section;
}

export function setSection(sectionId){
    section = sectionId;
}
